<template>
  <div>

    <el-row>

      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-checkbox v-model="radio" @change="changeRadioAction">{{ checkBoxMsg }}</el-checkbox>
        </el-form-item>
        <el-form-item label="当前月份">
          <el-date-picker v-model="formInline.payDate" style="width: 150px;" value-format="yyyy-MM" type="month"
                          placeholder="选择当前月份">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="比较月份">
          <el-date-picker v-model="formInline.historyDate" style="width: 150px;" value-format="yyyy-MM" type="month"
                          placeholder="选择比较月份">
          </el-date-picker>
        </el-form-item>
        <!--
                <el-form-item label="统计日期类型">
                  <el-select v-model="formInline.type" placeholder="请选择统计日期类型" style="width: 180px;">
                    <el-option label="税金所属月份" value="1"></el-option>
                    <el-option label="工资所属月份" value="2"></el-option>
                    &lt;!&ndash;<el-option label="开票所属月份" value="3"></el-option>
                    <el-option label="发放月份" value="4"></el-option>&ndash;&gt;
                    </el-select>
                </el-form-item>
        -->
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toColumnPage">自定义表头</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toExport">导出</el-button>
        </el-form-item>

      </el-form>
    </el-row>
    <div style="height: calc(100vh - 212px);">
      <vxe-grid
        id="comparison"
        show-footer
        resizable
        auto-resize
        border
        show-overflow
        ref="xGrid"
        align="center"
        width="100%"
        height="100%"
        :loading="loading"
        :show-header-overflow="true"
        :footer-method="footerMethod"
        :custom-config="{storage: true}"
        :columns="tableColumn"
        :data.sync="tableData"
      >
        <template v-slot:empty>
                    <span>
                      <svg class="icon icon-kong" aria-hidden="true" style="font-size: 40px;color: #999">
                            <use xlink:href="#icon-kong"></use>
                          </svg>
                      <p class="noData">暂无数据</p>
                    </span>
        </template>
      </vxe-grid>
    </div>
    <vxe-pager
      :loading="loading"
      :current-page="formInline.page"
      :page-size="formInline.limit"
      :total="formInline.total"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="handlePageChange">
    </vxe-pager>

    <el-dialog
      ref=""
      id="dialog1"
      width="740px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="自定义表头"
      :visible.sync="dialogheaderVisible"
    >
      <customHeader v-if="dialogheaderVisible" :headerList.sync="headerList" :headerData.sync="headerData">

      </customHeader>
      <div
        class="marginTop30"
        style="text-align: center"
      >
        <el-button
          type="primary"
          @click="saveCusHeader()"
        >
          确认
        </el-button>
        <el-button @click="dialogheaderVisible = false">
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import customHeader from "@/wage-components/ciic-custom-table-header/index";
import {addWageComparison, getWageComparisonColumnList, getWageComparisonColumnsList} from "@/api/report/report.js";
import {bspTableFilter} from "../../../filters";
import {mapGetters} from "vuex";
import XEUtils from 'xe-utils';
import exportMethod from '@/util/export.js'
import {deepCopy} from '@/util/util';

export default {
  components: {customHeader},
  created() {
    this._getWageComparisonColumnsList(this.formInline);
    this._getWageComparisonColumnList(this.formInline)
// 			addWageComparison({
// "entityList":[{},{}]
// }
// )
  },
  computed: {
    ...mapGetters([
      'dicts',
    ]),
  },
  methods: {
    //重置
    resetAction() {
      this.hidden = false;
      this.$refs.xGrid.resetColumn();
    },
    changeRadioAction() {
      if (this.radio) {
        this.hiddenAction();//隐藏
        //this.checkBoxMsg='重置';
      } else {
        this.resetAction();//重置
        //this.checkBoxMsg='隐藏空列';
      }
    },
    //隐藏
    hiddenAction() {
      this.expHiddenColumns = []; // 清空
      if (this.hiddenColumns && this.hiddenColumns.length > 0) {
        this.hidden = true;
        // 先收集所有需要隐藏的列对象
        const allCols = [];
        this.tableColumn.forEach(col => {
          // 检查自身field
          if (col.field && !this.hiddenColumns.includes(col.field)) {
            allCols.push(col);
          }
          // 检查分组列
          if (col.grounpColumns && Array.isArray(col.grounpColumns)) {
            const hasChild = col.grounpColumns.some(sub => !this.hiddenColumns.includes(sub.field));
            if (hasChild) {
              allCols.push(col);
            }
          }
        });
        // 去重
        this.expHiddenColumns = [...new Set(allCols)];
        // 然后执行隐藏操作，遍历hiddenColumns
        this.hiddenColumns.forEach(filed => {
          this.$refs.xGrid.hideColumn(this.$refs.xGrid.getColumnByField(filed));
        });
      }
    },
    footerMethod({columns, data}) {
      this.hiddenColumns = [];
      const result =  [
        columns.map((column, columnIndex) => {

          if (data && data.length > 0) {
            let columFiled = column.property;
            let result = XEUtils.every(data, (data) => {
              return data[columFiled] === 0 || data[columFiled] === null
                || data[columFiled] === '0' || data[columFiled] === '0.0' || data[columFiled] === '0.00'
            })
            if (result) {
              this.hiddenColumns.push(columFiled)
            }
          }

          if (columnIndex === 3) {
            return '合计'
          }
          if (this.sumListCode.includes(column.property)) {
            return XEUtils.sum(data, column.property)
          }
          return null
        })
      ]

      this.$nextTick(() => {
        if (this.radio) {
          this.hiddenAction();
        }
      });
      return result;
    },
    _getWageComparisonColumnsList(obj) {
      getWageComparisonColumnsList(obj).then(res => {
        this.headerData = res.data.checkLists;
        this.headerList = res.data.itemDatasList.length > 0 ? res.data.itemDatasList : res.data.sysDatas;
        this.sumListCode = res.data.sumListCode;

        let records = res.data.itemDatas.length > 0 ? res.data.itemDatas : res.data.sysLists;
        debugger
        let columns = records.map(column => {
          column.title = column.title ? column.title : column.itemNameCh;
          column.field = column.field;
          column.minWidth = 100;
          return column
        });
        // if(this.formInline.historyDate!='' && this.formInline.payDate!=''){
        columns.unshift({title: '证件号码', field: 'idCard', width: 100, fixed: 'left'});
        columns.unshift({
          title: '证件类型',
          field: 'idCardType',
          dataType: 'dict',
          setid: '3159',
          width: 100,
          fixed: 'left'
        });
        columns.unshift({title: '雇员姓名', field: 'empName', width: 100, fixed: 'left'});
        // }
        debugger;
        console.log(JSON.stringify(columns));
        columns.unshift({title: '序号', type: 'seq', width: 50, fixed: 'left'});


        this.tableColumn = columns;
      })
    },
    _getWageComparisonColumnList(obj) {
      getWageComparisonColumnList(obj).then(res => {
        this.tableData = res.data.records;
        for (let i = 0; i < res.data.records.length; i++) {
          let idCardType = bspTableFilter(res.data.records[i].idCardType, {'1': 'dict', 2: this.dicts})
          this.$set(this.tableData[i], 'idCardType', idCardType)
        }
        this.formInline.total = res.data.total;
        this.$nextTick(() => {
          if (this.radio) {
            this.hiddenAction();
          }
        });
      })
    },
    onSubmit() {
      if (this.formInline.monthType) {
        this._getWageComparisonColumnsList(this.formInline);
        this._getWageComparisonColumnList(this.formInline);
      } else {
        this.$message.error('请选择统计日期类型');

      }
    },
    handlePageChange({currentPage, pageSize}) {
      this.formInline.page = currentPage;
      this.formInline.limit = pageSize;
      this._getWageComparisonColumnList(this.formInline);
    },
    //跳转自定义表头设置
    toColumnPage() {
      this.dialogheaderVisible = true
    },
    saveCusHeader() {
      console.log(JSON.stringify({entityList: this.headerList}))
      addWageComparison({entityList: this.headerList}).then(res => {
        this.dialogheaderVisible = false;
        this._getWageComparisonColumnsList(this.formInline);
      })
    },
    toExport() {
      let cols = [];
      if (this.radio && this.expHiddenColumns && this.expHiddenColumns.length > 0) {
        cols = this.$clone(this.expHiddenColumns);
      } else {
        cols = this.$clone(this.tableColumn);
      }
      let column = deepCopy(cols);
      column.splice(0, 1);
      //单独处理前三列
      column.splice(0, 3,
        {
          title: '雇员信息', width: 100, fixed: 'left', colIndex: 3, grounpColumns: [
            {title: '雇员姓名', field: 'empName', width: 100, fixed: 'left', colIndex: 1},
            {
              title: '证件类型',
              field: 'idCardType',
              dataType: 'dict',
              setid: '3159',
              width: 100,
              fixed: 'left',
              colIndex: 1
            },
            {title: '证件号码', field: 'idCard', width: 100, fixed: 'left', colIndex: 1},
          ]
        },
      )

      exportMethod(
        {
          columns: column,
          type: "excel",
          beanName: "reportServiceImpl",
          methodName: "queryWageComparisonListPage",
          payDate: this.formInline.payDate,
          historyDate: this.formInline.historyDate,
          monthType: this.formInline.monthType,
          limit: this.formInline.limit,
          page: this.formInline.page,
          headerRowNum: 2,
          isHidden: this.radio,
          isSort: true,
          fileName: "工资对比表",
          filetype: ".xls",
        },
        "/wage", true
      );
    },
  },
  data() {
    return {
      hiddenColumns: [],//需要隐藏的列
      expHiddenColumns: [],//需要隐藏的列
      sumListCode: [],//需要合计的列
      dialogheaderVisible: false,
      radio: false,
      checkBoxMsg: '隐藏空列',
      formInline: {
        payDate: '',
        historyDate: '',
        monthType: '2',
        limit: 20,
        page: 1,
        total: 0
      },
      tableColumn: [],
      headerList: [],
      tableData: []
    }
  },
}
</script>
<style scoped>
.downLoad,
.del {
  font-size: 12px;
  margin-left: 20px;
  font-weight: 500;
  color: rgba(64, 158, 255, 1);
  line-height: 17px;
  cursor: pointer;
}

.fileName {
  padding-bottom: 10px;
  line-height: 17px;
}

.fileName img,
.fileName span {
  vertical-align: middle;
}

.fileName span {
  height: 17px;
  line-height: 17px;
}

.fileName span.oneOwner {
  padding-left: 42px;
}

.fileName img {
  margin-right: 20px;
}

.fileName:nth-last-of-type(1) {
  padding-bottom: 0;
}

.el-row {
  text-align: right;
  margin-bottom: 10px;
}

.upload {
  font-size: 12px;
  margin-right: 50px;
  font-weight: 500;
  color: rgba(64, 158, 255, 1);
  line-height: 17px;
}

.el-form--inline >>> .el-form-item {
  margin-bottom: 0;
}
</style>
